import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import AuthFooter from '../components/shared/AuthFooter/AuthFooter'
import UnlockWallet from '../components/UnlockWallet/UnlockWallet'
import { WALLET_UNLOCK_ACTIONS } from '../store/actions/wallet'
import requireWallet from '../hoc/requireWallet'

const { onPasswordChange, onUnlockWallet, resetUnlockState } = WALLET_UNLOCK_ACTIONS

class UnlockWalletContainer extends Component {

  componentWillUnmount() {
    this.props.resetUnlockState()
  }

  unlockWallet = () => {
    const { onUnlockWallet, history } = this.props
    onUnlockWallet({ history })
  }

  render() {
    return (
      <div className="main-container main-container--flex-column">
        <UnlockWallet
          {...this.props}
          unlockWallet={this.unlockWallet}
        />
        <AuthFooter />
      </div>
    )
  }
}

const mapStateToProps = ({ walletReducer }) => {
  const { unlockProfile } = walletReducer
  return {
    unlockProfile
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    onPasswordChange,
    onUnlockWallet,
    resetUnlockState
  }, dispatch)

export default requireWallet(connect(mapStateToProps, mapDispatchToProps)(UnlockWalletContainer))



// WEBPACK FOOTER //
// ./src/containers/UnlockWalletContainer.js